import React, { useState, useEffect } from 'react'
import { useSummaryFormContext } from '../hook/summary-form'
import { Box, Paper, Text, Divider, TextInput, Flex, Button, Group, Modal, ScrollArea, SimpleGrid, Select, Loader } from '@mantine/core'
import { CKEditor } from '@ckeditor/ckeditor5-react'
import { 
  ClassicEditor,
  Bold,
  Essentials,
  Italic,
  Mention,
  Paragraph,
  Undo,
  Font,
  Heading,
  List,
  Alignment,
  Link,
  PasteFromOffice,
  ImageInsertViaUrl,
  Image,
  ImageInsert,  Table, TableToolbar,
  Base64UploadAdapter,
} from 'ckeditor5'
import { downloadImageProductDescription } from '../../../../../../services/products'
import { getAllCityList, getAllCountryList, getAllDistrictList, getAllProvinceList } from '../../../../../../services/location'
import { notificationError, notificationSuccess } from '../../../../../ui/Notifications'
import { useParams } from 'react-router-dom'
import { getAllSupplierList } from '../../../../../../services/supplier'
import { getAllBrandList } from '../../../../../../services/brands'
import { getAllWarehouseList } from '../../../../../../services/warehouse'
import { useDebouncedCallback } from '@mantine/hooks'

const DataSummaryProduct = () => {
  const form = useSummaryFormContext()
  const params = useParams()
  const productId = params.product_id
  // expanding editor state
  const [isLoaded, setIsLoaded] = useState(false)
  const [editorInstance, setEditorInstance] = useState(null)
  const [editorHeight, setEditorHeight] = useState('500px')
  // download image
  const [loadingDownloadImage, setLoadingDownloadImage] = useState(false)
  // modal-preview description
  const [previewDescProduct, setPreviewDescProduct] = useState(false)
  // country
  const [countryList, setCountryList] = useState([])
  const [loadingCountry, setLoadingCountry] = useState(true)
  // province
  const [provinceList, setProvinceList] = useState([])
  const [loadingProvince, setLoadingProvince] = useState([])
  // city
  const [cityList, setCityList] = useState([])
  const [loadingCity, setLoadingCity] = useState([])
  // district
  const [districtList, setDistrictList] = useState([])
  const [loadingDistrict, setLoadingDistrict] = useState([])
  // supplier
  const [supplierList, setSupplierList] = useState([])
  const [loadingSuppliers, setLoadingSuppliers] = useState(true)
  const [searchSuppliers, setSearchSuppliers] = useState('')
  // brand
  const [brandList, setBrandList] = useState([])
  const [loadingBrands, setLoadingBrands] = useState(false)
  const [searchBrands, setSearchBrands] = useState('')
  // warehouse
  const [warehouseList, setWarehouseList] = useState([])



  const handleDownloadImageDesc = async (productId) => {
    setLoadingDownloadImage(true)
    try {
      const response = await downloadImageProductDescription(productId)
      if (response.success) {
        notificationSuccess('Download Images Description Product Success', 'You have been downloaded image from description product')
        window.open(`${response.data}`, '_blank')
      }
    } catch (error) {
      console.log(error)
      const errorMessage = error.response.data.message
      notificationError('Download Images Description Product Error', `${errorMessage ? errorMessage : 'Please contact your administrator'}`)
    } finally {
      setLoadingDownloadImage(false)
    }
  }

  const handleGetListCountry = async () => {
    setLoadingCountry(true)
    const parameter = {
      'page[num]': 1,
      'page[limit]': 300,
      'fields[country]': 'name',
    }
    try {
      const response = await getAllCountryList(parameter)
      const dataCountry = response.data
      const remapDataCountry = dataCountry.map((val) => {
        return {
          value: `${val.attributes.id}`,
          label: val.attributes.name
        }
      })
      setCountryList(remapDataCountry)
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingCountry(false)
    }
  }

  const handleGetListProvince = async (idCountry) => {
    setLoadingProvince(true)
    const parameter = {
      'page[num]': 1,
      'page[limit]': 9999,
      'filter[countries.id][is]': idCountry,
      'fields[province]': 'name',
    }
    try {
      const response = await getAllProvinceList(parameter)
      const dataProvince = response.data
      const remapDataProvince = dataProvince.map((val) => {
        return {
          value: `${val.attributes.id}`,
          label: val.attributes.name
        }
      })
      setProvinceList(remapDataProvince)
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingProvince(false)
    }
  }

  const handleGetListCity = async (idCountry, idProvince) => {
    setLoadingCity(true)
    const parameter = {
      'page[num]': 1,
      'page[limit]': 9999,
      'filter[countries.id][is]': idCountry,
      'filter[provinces.id][is]': idProvince,
      'fields[City]': 'name',
    }
    try {
      const response = await getAllCityList(parameter)
      const dataCity = response.data
      const remapDataCity = dataCity.map((val) => {
        return {
          value: `${val.attributes.id}`,
          label: val.attributes.name
        }
      })
      setCityList(remapDataCity)
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingCity(false)
    }
  }

  const handleGetListDistrict = async (idCountry, idProvince, idCity) => {
    setLoadingDistrict(true)
    const parameter = {
      'page[num]': 1,
      'page[limit]': 9999,
      'filter[countries.id][is]': idCountry,
      'filter[provinces.id][is]': idProvince,
      'filter[cities.id][is]': idCity,
      'fields[City]': 'name',
    }
    try {
      const response = await getAllDistrictList(parameter)
      const dataDistrict = response.data
      const remapDataDistrict = dataDistrict.map((val) => {
        return {
          value: `${val.attributes.id}`,
          label: val.attributes.name
        }
      })
      setDistrictList(remapDataDistrict)
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingDistrict(false)
    }
  }

  const handleGetListSupplier = useDebouncedCallback(async (supplierId) => {
    setLoadingSuppliers(true)
    const parameter = {
      'filter[id][is]': supplierId,
      'filter[name][like]': searchSuppliers,
      'page[num]': 1,
      'page[limit]': 6, // bad habbit
      'fields[supplier]': 'name,country_id,province_id,city_id,district_id',
      'include': 'country,province,city,district'
    }

    try {
      const response = await getAllSupplierList(parameter)
      if (response.success) {
        const dataSuppliers = response.data
        const remapDataSuppliers = dataSuppliers.map((val) => {
          return {
            value: `${val.attributes.id}`,
            label: `${val.attributes.name.charAt(0).toUpperCase() + val.attributes.name.slice(1)}`,
            country_id: val.attributes.country_id !== null && val.attributes.country_id !== 0 ? `${val.attributes.country_id}` : null,
            province_id: val.attributes.province_id !== null && val.attributes.province_id !== 0 ? `${val.attributes.province_id}` : null,
            city_id: val.attributes.city_id !== null && val.attributes.city_id !== 0 ? `${val.attributes.city_id}` : null,
            district_id: val.attributes.district_id !== null && val.attributes.district_id !== 0 ? `${val.attributes.district_id}` : null,
          }
        })
        setSupplierList(remapDataSuppliers)
      } else {
        setSupplierList([])
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingSuppliers(false)
    }
  }, 300)

  const handleGetListBrand = useDebouncedCallback(async (brandId) => {
    setLoadingBrands(true)
    const parameter = {
      'filter[id][is]': brandId,
      'filter[name][like]': searchBrands,
      'page[num]': 1,
      'page[limit]': 6, // bad habbit
      'fields[brand]': 'name'
    }

    try {
      const response = await getAllBrandList(parameter)
      if (response.success) {
        const dataBrands = response.data
        const remapDataBrands = dataBrands.map((val) => {
          return {
            value: `${val.attributes.id}`,
            label: `${val.attributes.name.charAt(0).toUpperCase() + val.attributes.name.slice(1)}`
          }
        })
        setBrandList(remapDataBrands)
      } else {
        setBrandList([])
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingBrands(false)
    }
  }, 300)

  const handleGetListWarehouse = async () => {
    const parameter = {
      'page[num]': 1,
      'page[limit]': 25, // bad habbit
      'sort': '-created_at'
    }

    try {
      const response = await getAllWarehouseList(parameter)
      const dataWarehouses = response.data
      const remapDataWarehouses = dataWarehouses.map((val) => {
        return {
          value: `${val.attributes.id}`,
          label: val.attributes.name,
          country_id: val.attributes.country !== null || val.attributes.country !== 0 ? `${val.attributes.country}` : null,
          province_id: val.attributes.province !== null || val.attributes.province !== 0 ? `${val.attributes.province}` : null,
          city_id: val.attributes.city !== null || val.attributes.city !== 0 ? `${val.attributes.city}` : null,
          district_id: val.attributes.district !== null || val.attributes.district !== 0 ? `${val.attributes.district}` : null,
        }
      })
      setWarehouseList(remapDataWarehouses)
    } catch (error) {
      console.log(error)
    }
  }

  // description input config
  const configEditor = {
    plugins:[
      Bold,
      Essentials,
      Italic,
      Mention,
      Paragraph,
      Undo,
      Font,
      Heading,
      List,
      Alignment,
      Link,
      PasteFromOffice,
      ImageInsertViaUrl,
      Image,
      ImageInsert,
      Table, TableToolbar,
      Base64UploadAdapter,
    ],
    alignment: {
      options: [ 'left', 'right' ]
    },
    fontSize: {
      options: [
          9,
          10,
          11,
          12,
          13,
          14,
          15,
          16,
          17,
          18,
          19,
          20,
          21,
          22
      ],
      supportAllValues: true
    },
    list: {
      properties: {
        styles: true,
        startIndex: true,
        reversed: true
      }
    },
    link: {
      decorators: {
        addTargetToExternalLinks: {
          mode: 'automatic',
          callback: url => /^(https?:)?\/\//.test( url ),
          attributes: {
              target: '_blank',
              rel: 'noopener noreferrer'
          }
        }
      }
    },
    toolbar: {
      items: [
        'undo', 'redo',
        '|',
        'heading',
        '|',
        'fontSize', 'Bold', 'Italic', 'alignment',
        '|',
        'link',
        '|',
        'bulletedList', 'numberedList',
        '|',
        'insertImage',
        '|',
        'insertTable'
      ],
      shouldNotGroupWhenFull: true
    },
    initialData: ''
  }

  const handlingInitEditor = (editor) => {
    editor.execute('fontSize', { value: '12px' })
    editor.editing.view.change((writer) => {
      writer.setStyle(
        'height',
        '500px',
        editor.editing.view.document.getRoot()
      )
    })
    setEditorInstance(editor)
  }

  const initEditorDescription = () => {
    return (
      <CKEditor
        editor={ClassicEditor}
        config={configEditor}
        data={form.values.description}
        onReady={handlingInitEditor}
        onChange={( event, editor ) => {
          editor.execute('fontSize', { value: '12px' })
          const valueEditor = editor.getData()
          form.setFieldValue('description', valueEditor)
        }}
      />
    )
  }

  useEffect(() => {
    handleGetListSupplier()
    // eslint-disable-next-line
  }, [searchSuppliers])

  useEffect(() => {
    handleGetListBrand()
    // eslint-disable-next-line
  }, [searchBrands])

  useEffect(() => {
    handleGetListCountry()
    handleGetListWarehouse()
    setIsLoaded(true)
  }, [])

  form.watch('supplier_id', ({ currentValue, value }) => {
    const selectedWarehouses = form.values.warehouses
    if (selectedWarehouses === null) {
      form.resetField('country_id')
      form.resetField('province_id')
      form.resetField('city_id')
      form.resetField('district_id')

      form.setValues((prev) => ({
        ...prev,
        country_id: null,
        province_id: null,
        city_id: null,
        district_id: null
      }))

      setProvinceList([])
      setCityList([])
      setDistrictList([])
      const supplierSelected = supplierList.find((val) => val.value === value)
      if (supplierSelected) {
        form.setValues((prev) => (
          {
            ...prev,
            country_id: supplierSelected.country_id,
            province_id: supplierSelected.province_id,
            city_id: supplierSelected.city_id,
            district_id: supplierSelected.district_id
          }
        ))
      }
    }
  })

  form.watch('warehouses', ({ currentValue, value }) => {
    form.resetField('country_id')
    form.resetField('province_id')
    form.resetField('city_id')
    form.resetField('district_id')

    form.setValues((prev) => ({
      ...prev,
      country_id: null,
      province_id: null,
      city_id: null,
      district_id: null
    }))

    setProvinceList([])
    setCityList([])
    setDistrictList([])
    const selectedWarehouses = form.getValues().warehouses
    if (selectedWarehouses) {
      const warehouseSelected = warehouseList.find((val) => val.value === value)
      if (warehouseSelected) {
        form.setValues((prev) => (
          {
            ...prev,
            country_id: warehouseSelected.country_id,
            province_id: warehouseSelected.province_id,
            city_id: warehouseSelected.city_id,
            district_id: warehouseSelected.district_id
          }
        ))
      }
    }
  })

  form.watch('country_id', ({ previousValue, value }) => {
    if (previousValue) {
      if (previousValue !== value) {
        form.setValues((prev) => ({ ...prev, province_id: null, city_id: null, district_id: null }))
        setProvinceList([])
        setCityList([])
        setDistrictList([])
      }
    }
    if (value !== null) {
      handleGetListProvince(value)
      form.setValues((prev) => ({ ...prev, country_id: value }))
    } else {
      setProvinceList([])
      setCityList([])
      setDistrictList([])
      form.setValues((prev) => ({ ...prev, province_id: null, city_id: null, district_id: null }))
    }
  })

  form.watch('province_id', ({ previousValue, value }) => {
    if (previousValue) {
      if (previousValue !== value) {
        form.setValues((prev) => ({ ...prev, city_id: null, district_id: null }))
        setCityList([])
        setDistrictList([])
      }
    }
    if (value !== null) {
      handleGetListCity(form.getValues().country_id, value)
      form.setValues((prev) => ({ ...prev, province_id: value }))
    } else {
      setCityList([])
      setDistrictList([])
      form.setValues((prev) => ({ ...prev, city_id: null, district_id: null }))
    }
  })

  form.watch('city_id', ({ previousValue, value }) => {
    if (previousValue) {
      if (previousValue !== value) {
        form.setValues((prev) => ({ ...prev, district_id: null }))
        setDistrictList([])
      }
    }
    if (value !== null) {
      handleGetListDistrict(form.getValues().country_id, form.getValues().province_id, value)
      form.setValues((prev) => ({ ...prev, city_id: value }))
    } else {
      setDistrictList([])
      form.setValues((prev) => ({ ...prev, district_id: null }))
    }
  })

  form.watch('district_id', ({ value }) => {
    if (value) {
      form.setValues((prev) => ({ ...prev, district_id: value }))
    } else {
      form.setValues((prev) => ({ ...prev, district_id: null }))
    }
  })

  form.watch('supplier_id', ({ value }) => {
    if (value) {
      handleGetListSupplier(value)
    }
  })

  form.watch('brand_id', ({ value }) => {
    if (value) {
      handleGetListBrand(value)
    }
  })

  const loadingDataTemplate = () => {
    return (
      <Box ta='center' my={12}>
        <Loader size={16} />
        <Text c='gray.6' fz={11}>Loading Data</Text>
      </Box>
    )
  }

  const changeHeightEditor = () => {
    if (editorInstance) {
      const newHeight = editorHeight === '500px' ? '1000px' : '500px'
      editorInstance.ui.view.editable.element.style.minHeight = newHeight
      setEditorHeight(newHeight)
    }
  }

  const onClosePreviewDescProduct = () => {
    setPreviewDescProduct(false)
  }

  const renderDescriptionProduct = (description) => {
    const renderHtml = { __html: description }
    return (
      <Box>
        <ScrollArea h={550} type="always" offsetScrollbars>
          <Box>
            <Box component='div' style={{ width: '100%' }} className="ck-content" dangerouslySetInnerHTML={renderHtml} />
          </Box>
        </ScrollArea>
        <Box mt={20}>
          <Flex justify='flex-end'>
            <Group>
              <Button size='xs' variant="outline" onClick={() => onClosePreviewDescProduct()}>Close</Button>
            </Group>
          </Flex>
        </Box>
      </Box>
    )
  }

  return (
    <Box>
      <Paper my={'xl'} p={'md'} withBorder shadow="xs" radius="md">
        <Text fw={500}>
          Product Data
        </Text>

        <Divider my={10} />

        <SimpleGrid cols={2} spacing="xl" verticalSpacing="xl" style={{ margin: '20px 0' }}>
          <TextInput
            label="Product Name"
            placeholder="Input Product Name Here"
            key={form.key('title')}
            {...form.getInputProps('title')}
            withAsterisk
          />

          <TextInput
            label="Slug"
            placeholder="Input Slug Here"
            key={form.key('slug')}
            {...form.getInputProps('slug')}
            withAsterisk
          />
        </SimpleGrid>

        <Box style={{ margin: '20px 0' }}>
          <Flex justify='space-between' align='center' mb={10}>
            <Text size="sm" fw={500}>
              Description
            </Text>
            <Group gap='md'>
              <Button size='xs' variant='light' loading={loadingDownloadImage} onClick={() => handleDownloadImageDesc(productId)} disabled={form.values.description === ''}>Download Images</Button>
              <Button size='xs' variant='light' onClick={() => setPreviewDescProduct(true)} disabled={form.values.description === ''}>See Preview</Button>
            </Group>
          </Flex>
          {isLoaded ? initEditorDescription() : ''}
          <Flex justify='flex-end' mt={20}>
            <Button size='xs' variant='light' onClick={() => changeHeightEditor()}>{editorHeight === '500px' ? 'Expand' : 'Minimize'} Description</Button>
          </Flex>
        </Box>

        <Box style={{ margin: '20px 0' }}>
          <SimpleGrid cols={4} spacing="xl" verticalSpacing="xl">
            <Select
              name='supplier'
              label="Supplier"
              data={supplierList}
              key={form.key('supplier_id')}
              {...form.getInputProps('supplier_id')}
              searchable
              searchValue={searchSuppliers}
              onSearchChange={setSearchSuppliers}
              nothingFoundMessage={!loadingSuppliers ? supplierList.length > 0 ? '' : 'No Supplier Found' : loadingDataTemplate()}
              clearable
              allowDeselect={false}
              withAsterisk
            />
            <Select
              name='brand'
              label="Brand"
              data={brandList}
              key={form.key('brand_id')}
              {...form.getInputProps('brand_id')}
              searchable
              searchValue={searchBrands}
              onSearchChange={setSearchBrands}
              nothingFoundMessage={!loadingBrands ? brandList.length > 0 ? '' : 'No Brand Found' : loadingDataTemplate()}
              clearable
              allowDeselect={false}
            />
            <Select
              name='warehouse'
              label="Warehouse"
              data={warehouseList}
              key={form.key('warehouses')}
              {...form.getInputProps('warehouses')}
              clearable
              allowDeselect={false}
            />
          </SimpleGrid>
        </Box>

        <Box style={{ margin: '20px 0' }}>

          <SimpleGrid cols={4} spacing="xl" verticalSpacing="xl">
            <Select
              name='country'
              label="Country"
              data={countryList}
              key={form.key('country_id')}
              {...form.getInputProps('country_id')}
              searchable
              clearable
              autoSelectOnBlur
              nothingFoundMessage={!loadingCountry ? countryList.length > 0 ? '' : 'No Country Found' : loadingDataTemplate()}
              allowDeselect={false}
              withAsterisk
            />
            <Select
              name='province'
              label="Province"
              data={provinceList}
              key={form.key('province_id')}
              {...form.getInputProps('province_id')}
              searchable
              clearable
              autoSelectOnBlur
              nothingFoundMessage={!loadingProvince ? provinceList.length > 0 ? '' : 'No Province Found' : loadingDataTemplate()}
              disabled={form.values.country_id === null}
              allowDeselect={false}
            />
            <Select
              name='city'
              label="City"
              data={cityList}
              key={form.key('city_id')}
              {...form.getInputProps('city_id')}
              searchable
              clearable
              autoSelectOnBlur
              nothingFoundMessage={!loadingCity ? cityList.length > 0 ? '' : 'No City Found' : loadingDataTemplate()}
              disabled={form.values.province_id === null}
              allowDeselect={false}
            />
            <Select
              name='district'
              label="District"
              data={districtList}
              key={form.key('district_id')}
              {...form.getInputProps('district_id')}
              searchable
              clearable
              autoSelectOnBlur
              nothingFoundMessage={!loadingDistrict ? districtList.length > 0 ? '' : 'No Distroct Found' : loadingDataTemplate()}
              disabled={form.values.city_id === null}
              allowDeselect={false}
            />
          </SimpleGrid>
        </Box>
      </Paper>
      <Modal opened={previewDescProduct} onClose={onClosePreviewDescProduct} closeOnClickOutside={false} centered size='90%' title={<Text fw='Bold'>Preview Description</Text>}  scrollAreaComponent={ScrollArea.Autosize} withCloseButton={false}>
        <Box>
          {previewDescProduct ? renderDescriptionProduct(form.values.description) : ''}
        </Box>
      </Modal>
    </Box>
  )
}

export default DataSummaryProduct